import React, { useEffect, useMemo, useState } from "react";
import CustomModal from "../../../../Shared/CustomModal";
// import CustomSelect from "../FilterTCU/CustomSelect";
import styles from "./TCUVehiclePopover.module.css";
import { BadgeInfo, DownloadIcon } from "lucide-react";
import TCUDeviceDetails from "./TCUDeviceDetails";
import { downloadTCUVehicleData, getDepotByCity, getVehiclesByDepot } from "../../../../../services/cesl-bus/tcuService";
import { useTCUContextData } from "../Context";
import ChartLoader from "../../../../Shared/Loader";

export default function TCUVehiclePopover({ selectedCity, bucketFilter,selectedDepot }) {
    const { GlobalFilter } = useTCUContextData()
    const [depots, setDepots] = useState([])
    const [vehicles, setVehicle] = useState([])
    // const [selectedDepots, setSelectedDepots] = useState([]);
    // const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    // useEffect(() => {
    //     /* Get All Depots */
    //     setSelectedDepots([]);
    //     setSelectedVehicle(null);
    //     let city = [{ label: selectedCity, value: selectedCity }]
    //     getDepotByCity({ ...GlobalFilter, city, bucketFilter })
    //         .then(res => setDepots(res?.data || []))
    //         .catch(() => setDepots([]))
    // }, [selectedCity, bucketFilter])

    useEffect(() => {
        setIsLoading(true)
        let city = [{ label: selectedCity, value: selectedCity }]
        let depot=[{ label: selectedDepot, value: selectedDepot }]

        getVehiclesByDepot({ ...GlobalFilter, city, depot: depot, bucketFilter })
            .then(res => {
                setVehicle(res?.data || [])
                setIsLoading(false)
            })
            .catch(() => {
                setVehicle([])
                setIsLoading(false)
            })
    }, [selectedCity, bucketFilter, selectedDepot])

    // const handleDepotChange = options => {
    //     setSelectedDepots(options || []);
    // };


    const OpenDetails = regNo => {
        const vehicle = vehicles?.find(
            vehicle => vehicle.reg === regNo
        );

        if (!vehicle) return;

        // setSelectedVehicle(vehicle);

        setTimeout(() => {
            window.modal_tcuVehicleInfo?.show();
        }, 0);
    };

    function downloadVehicleData() {
        let city = [{ label: selectedCity, value: selectedCity }]
        let depot=[{ label: selectedDepot, value: selectedDepot }]
        downloadTCUVehicleData({ ...GlobalFilter, city, depot, bucketFilter })
            .then((data) => {
                const url = window.URL.createObjectURL(data);
                const link = document.createElement("a");
                link.href = url;
                link.download = `${selectedCity}LostTCUandAgingVehicle.csv`;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            })
            .catch(() => { })
    }

    return (
        <>
            {/* Main Vehicle Modal */}
            <CustomModal
                id="tcuVehicleDetails"
                title={`Lost TCU & Ageing for city: ${selectedCity}`}
                size="modal-xl"
                header={true}
                closeBtnClass="btn ms_btn btn-default"
            >
                <div className={styles.modalBody}>

                    <div className={styles.filterContainer}>

                        {/* <div className={styles.selectWrapper}>
                            <CustomSelect
                                name="depot"
                                options={depots}
                                value={selectedDepots}
                                isMulti={true}
                                placeholder="Select Depo"
                                onChange={handleDepotChange}
                            />
                        </div> */}

                        <span
                            type="button"
                            className={"custom-Btn-animation ml-auto"}
                            onClick={downloadVehicleData}
                            // disabled={!vehicles.length}
                            title="Download"
                        >
                            <DownloadIcon size={16} />
                        </span>

                    </div>

                    <div>
                        <div className={`table-responsive ${styles.tableContainer}`}>
                            <table
                                className={`table table-bordered table-hover align-middle mb-0 ${styles.vehicleTable}`}
                            >
                                <thead
                                    className="sticky-top"
                                    style={{ zIndex: 1 }}
                                >
                                    <tr>
                                        <th style={{ width: "50px" }}>Sr. No.</th>
                                        <th>Depo</th>
                                        <th>Reg No</th>
                                        <th>VIN ID</th>
                                        <th>Ageing Days</th>
                                        <th>Last TCU Active Date</th>
                                        <th>Device Details</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {
                                        isLoading ?
                                            <ChartLoader />
                                            : vehicles.length ? vehicles.map((vehicle, index) => (
                                                <tr key={`${vehicle.reg}-${index}`}>
                                                    <td>{index + 1}</td>
                                                    <td>{vehicle.Depot || "--"}</td>
                                                    <td className={styles.regNo}>{vehicle.regNo || "--"}</td>
                                                    <td>{vehicle.VIN || "--"}</td>
                                                    <td>{vehicle.ageing_days ?? "--"}</td>
                                                    <td>{vehicle.last_date ?? "--"}</td>
                                                    <td>
                                                        <span
                                                            className="custom-Btn-animation ms_btn"
                                                            // onClick={() =>
                                                            //     OpenDetails(vehicle.reg)
                                                            // }
                                                            title="View Device Details"
                                                            style={{
                                                                cursor: "pointer"
                                                            }}
                                                        >
                                                            <BadgeInfo size={18} />
                                                        </span>
                                                    </td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={7} >
                                                    <div className="v-title">
                                                        <div className="">
                                                            <div className="alert alert-danger no_data text-center">Records not found</div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>}
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
            </CustomModal>

            {/* Vehicle Details Modal */}
            <TCUDeviceDetails selectedVehicle />
        </>
    );
}